import React, { useCallback } from 'react';
import { enhancedTheme } from './utils';

const PortButton = ({
  port,
  label,
  slotNumber,
  selected,
  connected,
  registered,
  onClick,
  onRegisterAnchor,
  size = 14,
}) => {
  const portId = port?._id;

  const handleRef = useCallback(
    (el) => {
      if (onRegisterAnchor && portId) {
        onRegisterAnchor(portId, el);
      }
    },
    [onRegisterAnchor, portId],
  );

  const isClickable = Boolean(port);
  const displayNum = slotNumber || label;

  let bg = enhancedTheme.portEmpty;
  let border = '1px solid #bdbdbd';
  if (port) {
    bg = connected
      ? '#bae7ff'
      : registered !== false
        ? '#d9f7be'
        : '#f0f0f0';
    border = connected ? '2px solid #1890ff' : '1px solid #52c41a';
  }
  if (selected) {
    bg = '#efdbff';
    border = '2px solid #722ed1';
  }

  return (
    <button
      type="button"
      ref={handleRef}
      title={
        port
          ? `${port.interface}${port.description ? ` — ${port.description}` : ''}`
          : `Port ${displayNum} (not in registry)`
      }
      disabled={!isClickable}
      onClick={() => isClickable && onClick && onClick(port)}
      style={{
        width: size,
        height: size,
        padding: 0,
        border,
        backgroundColor: bg,
        borderRadius: 3,
        cursor: isClickable ? 'pointer' : 'default',
        flexShrink: 0,
        fontSize: size <= 10 ? 0 : 8,
        lineHeight: `${size}px`,
        color: '#434343',
        fontWeight: 600,
        opacity: isClickable ? 1 : 0.55,
      }}
    >
      {size >= 12 && displayNum ? displayNum : ''}
    </button>
  );
};

export default PortButton;
